import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'timeAgo',
  standalone: true,
  pure: true
})
export class TimeAgoPipe implements PipeTransform {
  constructor(private readonly standardDatePipe: DatePipe) {}

  transform(value: Date | string | number | null | undefined): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    const date = new Date(value);
    const now = new Date();

    const MILISEC = 1000;
    const SEC = 60;
    const MINUTE = 60;
    const DAY = 24;

    const diffMs = now.getTime() - date.getTime();
    const diffMinutes = Math.floor(diffMs / (MILISEC * SEC));
    const diffHours = Math.floor(diffMs / (MILISEC * SEC * MINUTE));
    const diffDays = Math.floor(diffMs / (MILISEC * SEC * MINUTE * DAY));

    // 1. 'Few minutes' if max 5 minutes ago
    if (diffMinutes >= 0 && diffMinutes <= 5) {
      return 'Few minutes ago';
    }

    // 2. 'X hours' if today and at most 12 hours ago
    if (diffHours >= 1 && diffHours <= 12) {
      if (
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear()
      ) {
        return `${diffHours} hours ago`;
      }
    }

    const isSameDay = (d1: Date, d2: Date) =>
      d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();

    // 3. 'Today' if date day is today
    if (isSameDay(date, now)) {
      return 'Today';
    }

    // 4. 'Yesterday' if date day was yesterday
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (isSameDay(date, yesterday)) {
      return 'Yesterday';
    }

    // 5. 'X days' if at most 10 days ago OR is in the current month
    const isWithinTenDays = diffDays >= 1 && diffDays <= 10;
    const isCurrentMonth = date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();

    if (isWithinTenDays || isCurrentMonth) {
      if (diffDays >= 1) {
        return `${diffDays} days ago`;
      }

      return this.standardDatePipe.transform(date, 'mediumDate');
    }

    //6. 'X months' in other cases
    const diffMonths = (now.getFullYear() - date.getFullYear()) * 12 + (now.getMonth() - date.getMonth());
    if (diffMonths >= 1) {
      return `${diffMonths} months ago`;
    }

    return this.standardDatePipe.transform(date, 'mediumDate');
  }
}
